import axios from 'axios';
import { toast } from 'react-toastify';
import {
  DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_BEGIN,
  DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_SUCCESS,
  DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_FAILURE,
  DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteExportRequest(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(args.projectId, true);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/code-export/${args.id}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_SUCCESS,
              data: res.data,
            });
            toast.success('Request Deleted Successfully');
            resolve(res);
          } else {
            dispatch({
              type: DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_FAILURE,
              data: { error: err },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteExportRequestError() {
  return {
    type: DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_BEGIN:
      return {
        ...state,
        deleteExportRequestPending: true,
        deleteExportRequestError: null,
      };

    case DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_SUCCESS:
      return {
        ...state,
        deleteExportRequestPending: false,
        deleteExportRequestError: null,
        exportRequestList: action.data,
      };

    case DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_FAILURE:
      return {
        ...state,
        deleteExportRequestPending: false,
        deleteExportRequestError: action.data.error,
      };

    case DEPLOYMENT_SETTING_DELETE_EXPORT_REQUEST_DISMISS_ERROR:
      return {
        ...state,
        deleteExportRequestError: null,
      };

    default:
      return state;
  }
}
